export default "__VITE_ASSET__NiNfV0Hm__"